import { useEffect, useState, useRef } from 'react'
import { useNotification } from '../../../hooks/useNotification';
import { useForm } from "../../../hooks/useForm";
import { useErrorInputs } from "../../../hooks/useErrorInputs";
import { useAudit } from "../../../hooks/useAudit";
import { useNavigate } from 'react-router-dom';
import { useApiResolver } from '../../../hooks/useApiResolver';

const baseUrl = process.env.REACT_APP_URL_PATH;
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;
const env = process.env.REACT_APP_ENV_BUILD;

export function useManageEpayco(token, subscriptionPlan) {
    const navigate = useNavigate();
    const captchaRef = useRef(null);
    const { resolveValue } = useApiResolver();
    const { getAuditData } = useAudit();
    const [sendNotification] = useNotification();

    const [captchaToken, setCaptchaToken] = useState(null);
    const [sdkReady, setSdkReady] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, handleInputChange] = useForm({
        full_username: "",
        email: "",
        phone: "",
        tax_id: "",
        id_number: "",
        company_name: "",
        address: "",
        otpVefication: "",
        terms_conditions: false,
        habeasData: false,
    });
    const requiredFields = ['full_username', 'phone', 'email', 'tax_id', 'id_number', 'company_name', 'address', 'terms_conditions', 'habeasData'];
    const [errorInputs, , , validForm] = useErrorInputs({});

    useEffect(() => {
        if (window.ePayco) {
            setSdkReady(true);
            return;
        }

        const script = document.createElement("script");
        script.src = "https://checkout.epayco.co/checkout.js";
        script.async = true;

        script.onload = () => setSdkReady(true);
        document.body.appendChild(script);

        return () => {
            // optional cleanup
            // document.body.removeChild(script);
        };
    }, []);

    const onChange = (tokenCaptcha) => {
        setCaptchaToken(tokenCaptcha);
    };

    const onExpired = () => {
        setCaptchaToken(null);
    };

    const SendEmailOtp = async () => {
        if (!captchaToken) {
            alert("Por favor, completa el reCAPTCHA");
            return;
        }

        const auditData = await getAuditData();

        const config = {
            method: 'POST',
            url: baseUrlFlow,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic OTAwMTE0MDk4OnNlYnlIcFdZcWlZM0RIVllsODhjWmFYaVNNSlNCZ0VrOXFDNU9SUUJlNUFyZk01NU95MTRWZUY2eGsyczcyOTA`
            },
            data: JSON.stringify({
                id_flow: "900114098-SEND-OTP-EPAYCO",
                clientToken: captchaToken,
                token: token,
                plan_uuid: subscriptionPlan,
                email: form.email,
                full_username: form.full_username,
                phone: form.phone,
                tax_id: form.tax_id,
                id_number: form.id_number,
                company_name: form.company_name,
                address: form.address,
                terms_conditions: form.terms_conditions,
                habeasData: form.habeasData,
                auditData
            })
        };

        const { data, status } = await resolveValue(config);
        console.log('900114098-SEND-OTP-EPAYCO ', { data, status })
        if (status === 200) {
            if (data.catpcha === 'INVALIDO')
                sendNotification({ msg: "Por favor resuelva el catpcha y vuelva a intentarlo", variant: 'info' });
            else if (data.token === 'INVALIDO') {
                sendNotification({ msg: "La sessión expiro por favor vuelva a intentarlo", variant: 'info' });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
            else
                setOtpSent(true);
        }
        setTimeout(() => setLoading(false), 2000);
    };

    const OpenEapyco = (info_plan) => {
        const handler = window.ePayco.checkout.configure({
            key: "4c06eb02ecaad89594af99cab23e3a2e",
            test: env === 'prod' ? false : true,
        });

        const data = {
            name: "Registro y acceso al sistema AIAutomation",
            description: `Plan AIAutomation ${info_plan.plan_name} - ${info_plan.billing_cycle}`,
            invoice: "AIA-" + Date.now(),
            currency: "COP",
            amount: info_plan.plan_price,
            tax_base: "0",
            tax: "0",
            country: "CO",
            lang: "es",
            external: "true",
            // Extra info
            extra1: info_plan.id_unique,
            extra2: subscriptionPlan,
            response: `${baseUrl}/payment-response`,
            confirmation: baseUrlFlow,
            url_confirmation: baseUrlFlow,
            "data-epayco-confirmation": baseUrlFlow,
            p_confirm_method: "POST",
            name_billing: form.full_username,
            address_billing: form.address,
            type_doc_billing: form.tax_id,
            mobilephone_billing: form.phone,
            number_doc_billing: form.id_number,
        };
        handler.open(data);
        setTimeout(() => setLoading(false), 1000);
    }

    const validateCode = async () => {
        if (!validForm(['otpVefication'], form)) {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
            return;
        }
        setLoading(true);
        const config = {
            method: 'POST',
            url: baseUrlFlow,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic OTAwMTE0MDk4OnNlYnlIcFdZcWlZM0RIVllsODhjWmFYaVNNSlNCZ0VrOXFDNU9SUUJlNUFyZk01NU95MTRWZUY2eGsyczcyOTA`
            },
            data: JSON.stringify({
                id_flow: "900114098-VALIDATE-OTP-EPAYCO",
                otp: form.otpVefication,
                id_unique: token
            })
        };
        const { data, status } = await resolveValue(config);
        if (status === 200 && data.status === 'VALIDO') {
            if (data.redirect_epayco === 'true')
                OpenEapyco(data);
            else
                setTimeout(() => {
                    navigate('/Loguin');
                }, 2000);
        }
        else {
            sendNotification({ msg: "Código de verificación incorrecto", variant: 'error' });
        }
        setLoading(false);
    }

    const handleSubmit = () => {
        if (!validForm(requiredFields, form) || !form.terms_conditions || !form.habeasData) {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
            return;
        }
        setLoading(true);
        SendEmailOtp();
    };

    const handleCancel = () => navigate('/login');

    return {
        form,
        captchaToken,
        captchaRef,
        sdkReady,
        errorInputs,
        otpSent,
        loading,
        handleInputChange,
        handleSubmit,
        onChange,
        onExpired,
        validateCode,
        handleCancel
    }
}
